import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  restrictedTooltip: {
    id: 'proforma-form-security.config-button.restricted-tooltip',
    defaultMessage: 'Only specific people can view this form',
    description: 'Text for the form permission button tooltip to show it is restricted.'
  },
  restrictedViewModeTooltip: {
    id: 'proforma-form-security.config-button.restricted-view-mode-tooltip',
    defaultMessage: 'View restrictions',
    description: 'Text for the view-mode form permission button tooltip to show it is restricted.'
  },
  openTooltip: {
    id: 'proforma-form-security.config-button.open-tooltip',
    defaultMessage: 'Anyone can view this form',
    description: 'Text for the form permission button tooltip to show it is open.'
  },
  restricted: {
    id: 'proforma-form-security.config-button.restricted',
    defaultMessage: 'Restrictions apply on submitted forms',
    description: 'Label attribute for the form permission button to show it is restricted.'
  },
  open: {
    id: 'proforma-form-security.config-button.open',
    defaultMessage: 'No restrictions apply on submitted forms',
    description: 'Label attribute for the form permission button to show it is open.'
  },
  restrictedLabelAttribute: {
    id: 'proforma-form-security.config-button.restricted-label-attribute',
    defaultMessage: 'Manage restrictions, restrictions applied',
    description: 'Label attribute for the form permission button to show it is restricted.'
  },
  openLabelAttribute: {
    id: 'proforma-form-security.config-button.open-label-attribute',
    defaultMessage: 'Manage restrictions, no restrictions applied',
    description: 'Label attribute for the form permission button to show it is open.'
  },
  viewModeButtonLabel: {
    id: 'proforma-form-security.config-button.view-mode-button-label',
    defaultMessage: 'View form restrictions',
    description: 'Label attribute for the form permission button to view form restrictions.'
  }
});